module.exports = __webpack_public_path__ + "static/img/error.9c936970.png";